import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Store from 'drip/store';
export default {
  name: 'GrabTickets',
  props: {
    prefillCompleted: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: Number,
      default: null
    },
    needPreInput: {
      type: Boolean,
      default: false
    },
    needPreSelect: {
      type: Number,
      default: 0
    },
    modelStyle: {
      type: Number
    },
    title: {
      type: String
    },
    start: {
      type: Number
    },
    isNewPage: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (!this.prefillCompleted) {
      window.seedAction({
        evt: 'view',
        bid: 'b_movie_0j0meois_mv',
        cid: 'c_c21utqjf',
        abtest: 1,
        custom: {
          performance_id: this.projectId
        }
      });
    }
  },
  methods: {
    gotoGrabPage: function gotoGrabPage() {
      if (!this.needPreInput) return;
      window.lxTagReport('c_c21utqjf', 'b_movie_0j0meois_mc', {
        performance_id: this.projectId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_0j0meois_mc',
        cid: 'c_c21utqjf',
        abtest: 1,
        custom: {
          performance_id: this.projectId
        }
      });
      if (this.projectId) {
        var title = encodeURIComponent(this.title);
        Store.set('detailPageShouldReload', true);
        var query = "projectId=".concat(this.projectId, "&needPreTicket=").concat(this.needPreSelect, "&modelStyle=").concat(this.modelStyle) + "&title=".concat(title, "&start=").concat(this.start, "&isNew=").concat(this.isNewPage, "&closekey=ticketStrategy");
        this.go("/ticket-strategy/?".concat(query));
      }
    }
  }
};